import { t } from '@trimble/i18n';
import { Component } from 'solid-js';
import { HeatmapSectionLabel } from '../../components/HeatmapSectionLabel';
import { heatmapHorizontalPreviewCss } from '../../heatmap-stop-layout';
import { EditableStop, TextureType } from '../../types/heatmap.types';
import { HeatmapPreviewBar } from '../../gradient-preview/HeatmapPreviewBar';

interface TextureSelectionProps {
  textureType: TextureType;
  setTextureType(type: TextureType): void;
  stops: EditableStop[];
  colorAboveRange?: string;
  colorBelowRange?: string;
}

export const TextureSelection: Component<TextureSelectionProps> = (props) => {
  const overflowOverrides = (): {
    above?: string;
    below?: string;
  } => ({
    above: props.colorAboveRange,
    below: props.colorBelowRange,
  });

  return (
    <div class="flex flex-col gap-2">
      <HeatmapSectionLabel
        label={t('measurements.volumetric.gradient.textureLabel')}
      />

      <label
        class="flex cursor-pointer items-start gap-2"
        for="texture-type-gradient"
        data-testid="texture-gradient-option"
        onClick={() => props.setTextureType('gradient')}
      >
        <modus-wc-radio
          size="sm"
          class="mt-0.5 shrink-0"
          name="texture-type"
          input-id="texture-type-gradient"
          value={props.textureType === 'gradient'}
          on:inputChange={() => props.setTextureType('gradient')}
        />
        <div class="flex flex-col gap-1 flex-1 min-w-0">
          <span class="m-0 text-sm font-medium">
            {t('measurements.volumetric.gradient.textureGradient')}
          </span>
          <HeatmapPreviewBar
            stops={props.stops}
            backgroundCss={heatmapHorizontalPreviewCss(
              props.stops,
              'gradient',
              overflowOverrides()
            )}
          />
          <span class="text-xs text-gray-6">
            {t('measurements.volumetric.gradient.textureGradientDesc')}
          </span>
        </div>
      </label>

      <label
        class="flex cursor-pointer items-start gap-2"
        for="texture-type-stepped"
        data-testid="texture-stepped-option"
        onClick={() => props.setTextureType('stepped')}
      >
        <modus-wc-radio
          size="sm"
          class="mt-0.5 shrink-0"
          name="texture-type"
          input-id="texture-type-stepped"
          value={props.textureType === 'stepped'}
          on:inputChange={() => props.setTextureType('stepped')}
        />
        <div class="flex flex-col gap-1 flex-1 min-w-0">
          <span class="m-0 text-sm font-medium">
            {t('measurements.volumetric.gradient.textureStepped')}
          </span>
          <HeatmapPreviewBar
            stops={props.stops}
            backgroundCss={heatmapHorizontalPreviewCss(
              props.stops,
              'stepped',
              overflowOverrides()
            )}
          />
          <span class="text-xs text-gray-6">
            {t('measurements.volumetric.gradient.textureSteppedDesc')}
          </span>
        </div>
      </label>
    </div>
  );
};
